import React, { useState } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { VARIANTS } from '../../utils/types/variants';
import { HireFreelancerTab } from '../HireFreelancerTab';
import { BrowseServicesTab } from '../BrowseServicesTab';
import { ChosenTab, TabConfig, Toggle } from './Toggle';

interface LongTermHiringVariantsProps {
  variant: typeof VARIANTS.B | typeof VARIANTS.C;
}

const tabsConfig: TabConfig[] = [
  {
    id: 'hire_a_freelancer',
    titleKey: 'logged_out_homepage.video_top_banner.long_term_hiring_experiment.hire_freelancer_tab.title',
    component: <HireFreelancerTab />,
  },
  {
    id: 'browse_services',
    titleKey: 'logged_out_homepage.video_top_banner.long_term_hiring_experiment.browse_services_tab.title',
    component: <BrowseServicesTab />,
  },
];

export const LongTermHiringVariants = ({ variant }: LongTermHiringVariantsProps) => {
  // Variant B: Hire Freelancer first, Browse Services second
  // Variant C: Browse Services first, Hire Freelancer second
  const orderedTabs = variant === VARIANTS.C ? [...tabsConfig].reverse() : tabsConfig;
  const [chosenTab, setChosenTab] = useState<ChosenTab>(orderedTabs[0].id);

  return (
    <Stack direction="column" gap="7">
      <Toggle tabsConfig={orderedTabs} chosenTab={chosenTab} setChosenTab={setChosenTab} />
      {tabsConfig.find((tab) => tab.id === chosenTab)?.component}
    </Stack>
  );
};
